import React, {Component} from 'react';
import {Steps, message} from 'antd';
import {Redirect} from 'react-router';
import './successfulPayment.less';

const Step = Steps.Step;

class SearchDetail extends Component {
  state = {
    detail: {}, // 订单详情
    orderNo: null, // 订单编号
    redirect: false,
    sourceCMS: '', // 来源标识
  }

  componentWillMount() {
    if (window.common.loginOut(this)) {
      const orderNo = this.props.location.state.order_no;
      const sourceCMS = window.localStorage.getItem('sourceCMS') || '';
      this.setState({orderNo, sourceCMS});
      this.getOrderDetail(orderNo);
    } else {
      message.error('登录信息失效，请重新登录');
    }
  }

  // 跳转到订单列表
  toOrderList = () => {
    this.props.history.push('/orderList');
  }

  // 跳转到订单详情
  toOrderDetail = () => {
    this.props.history.push('/orderDetail', {order_no: this.state.orderNo});
  }

  // 获取订单详情
  getOrderDetail = (orderNo) => {
    const params = {order_no: orderNo};
    window.api('order.orderList', params).then(res => {
      res.orders[0].real_amt = res.orders[0].real_amt.toFixed(2);
      this.setState({detail: res.orders[0]});
    }).catch((error) => {
      error.service_error_code === 'EPS000000801' ? this.setState({redirect: true}) : null;
      message.error(error.service_error_message);
    });
  }

  // 再次购买
  againBuy = () => {
    this.props.history.push('/searchDetail', {type: 'property', id: 3});
  }

  render() {
    const {detail, redirect, sourceCMS} = this.state;
    if (redirect) return (<Redirect to="/login" />);
    return (
      <div id="successfulPayment">
        <section>
          <div className="info">
            <div className="success">
              <p>您已成功付款 <span>{detail.real_amt}</span> 元</p>
            </div>
            <div className="address">
              <p>货物寄送至：</p>
              <p>{detail.province} {detail.city} {detail.area} {detail.address}</p>
            </div>
            <div className="link">
              <p>您可以查看：</p>
              <div>
                <span onClick={this.toOrderList}>订单列表</span>
                <p>|</p>
                <span onClick={this.toOrderDetail}>订单详情</span>

                {/* 来源标识为1时，显示再次购买 */}
                {sourceCMS === '1' && (
                  <React.Fragment>
                    <p>|</p>
                    <span onClick={this.againBuy}>再次购买</span>
                  </React.Fragment>
                )}

              </div>
            </div>
          </div>
          <div className="progress">
            <Steps current={2}>
              <Step title="提交订单" description="" />
              <Step title="支付成功" description="" />

              {/* 来源标识为1时，不显示正在发货和确认收货 */}
              {sourceCMS !== '1' && <Step title="正在发货" description="" />}
              {sourceCMS !== '1' && <Step title="确认收货" description="" />}

            </Steps>
          </div>
        </section>
      </div>
    );
  }
}

export default SearchDetail;



// WEBPACK FOOTER //
// ./src/containers/frontEnd/successfulPayment/successfulPayment.jsx